/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Order_Confirmation_Run_In_ProgressInputs */

const en_error_order_confirmation_run_in_progress = /** @type {(inputs: Error_Order_Confirmation_Run_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The order confirmations of this brand and season are still being issued.`)
};

/**
* | output |
* | --- |
* | "The order confirmations of this brand and season are still being issued." |
*
* @param {Error_Order_Confirmation_Run_In_ProgressInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_order_confirmation_run_in_progress = /** @type {((inputs?: Error_Order_Confirmation_Run_In_ProgressInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Order_Confirmation_Run_In_ProgressInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_order_confirmation_run_in_progress(inputs)
});